let language = {
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TITLE": "Transactions",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-EMPTY-TIPS": "The orders is empty",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-ORDER": "Order No",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-DATE": "Order Date",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-METHOD": "Method",
    "PAYMENTS-DASHBOARD-TRANSACTIONS-TABLE-HEADER-TOTAL-PRICE": "Total Price",

    "PAYMENTS-DASHBOARD-INVOICES-TITLE": "Invoices",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-NAME": "Name",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-PERIOD": "Period",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-REGION": "Country / Region",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-STORE": "Store",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-BUTTON-RESET": "Reset",
    "PAYMENTS-DASHBOARD-INVOICES-SEARCH-BUTTON-SEARCH": "Search",
    "PAYMENTS-DASHBOARD-INVOICES-BUTTON-BULK-DOWNLOAD": "Bulk download invoice",
    "PAYMENTS-DASHBOARD-INVOICES-ORDER-EMPTY-TIPS": "The orders is empty",
    "PAYMENTS-DASHBOARD-INVOICES-ORDER-EMPTY-ELIGIBLE-TIPS": "No eligible orders, please try other search criteria",

    // TABLE
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-NAME": "Name",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-REGION": "Country / Region",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-ORDER": "Order",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-AMOUNT": "Amount",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-CREATED": "Created",
    "PAYMENTS-DASHBOARD-INVOICES-HEADER-PDF": "PDF",
    
};

export { language }